import React, { useEffect, useState } from 'react';
import Validator from 'validatorjs';
import { Guardian } from '@xaamin/guardian';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import ObjetoImpDR from '../../../support/catalogs/ObjetoImpDR';
import FactorajeForm from '../../../factoraje/components/FactorajeForm';
import ResponseError from '../../../../../shared/responses/ResponseError';
import DocumentoRelacionadoImpuestos from './DocumentoRelacionadoImpuestos';
import DecimalForGlobals from '../../../support/impuestos/DecimalForGlobals';
import UsePreviousCfdiToFillForm from './components/UsePreviousCfdiToFillForm';
import MonedaDROptions from '../../../support/catalogs/complementos/pagos/MonedaPOptions';
import FactorajeFinancieroCalculator from '../../../support/factoraje/FactorajeFinancieroCalculator';
import ComplementoPagosDRRules from '../../../support/rules/complementos/pagos/ComplementoPagosDRRules';

const DocumentoRelacionadoForm = (props) => {
  const { data: editing, version } = props;

  const [data, setData] = useState({
    ObjetoImpDR: '01',
  });

  const [factoraje, setFactoraje] = useState({
    ...editing?.FactorajeFinanciero,
  });

  const [error, setError] = useState(undefined);

  const [validation, setValidation] = useState({
    isValid: false,
    validator: new Validator({}, ComplementoPagosDRRules({ ...data, version })),
  });

  const { isValid } = validation;

  const rules = ComplementoPagosDRRules(data);

  const validate = (data) => {
    const validator = new Validator(data, rules);

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidation(newValidator);
  };

  useEffect(() => {
    validate(data);
  }, [data]); // eslint-disable-line

  useEffect(() => {
    if (!!editing && !!editing.IdDocumento) {
      setData({
        ...editing,
        ObjetoImpDR: editing.ObjetoImpDR ?? '01',
      });
    }
  }, [editing]);

  const handleOnChange = (event) => {
    const newData = {
      ...data,
      ...event,
      ImpuestosDR: event.ObjetoImpDR !== '01' ? data.ImpuestosDR : {},
    };

    if (!!event.ImpPagado) {
      const { ImpSaldoAnt = 0 } = data;
      const { ImpPagado = 0 } = newData;
      const saldoInsoluto = parseFloat(ImpSaldoAnt) - parseFloat(ImpPagado);

      newData.ImpSaldoInsoluto = DecimalForGlobals.make(saldoInsoluto).toFixed(2);
    }

    setData(newData);
  };

  const handleOnImpuestosChange = (impuestos) => {
    const newData = {
      ...data,
      ImpuestosDR: {
        ...data.ImpuestosDR,
        ...impuestos,
      },
    };

    setData(newData);
  };

  const handleOnAdd = () => {
    const newData = {
      ...data,
      FactorajeFinanciero: factoraje,
    };

    props.onAdd(newData);

    setData({});
  };

  const handleOnStartPointChange = (value) => {
    if (['P', 'N', 'T'].includes(value.TipoDeComprobante) || value.MetodoPago !== 'PPD') {
      setError({
        code: '404',
        message:
          'El Comprobante no es una factura de Ingreso/Egreso ó metodo de pago diferente a PPD para relacionar el pago.',
      });

      return;
    }

    const uuid =
      value.Complemento?.TimbreFiscalDigital?.UUID ?? value.Complemento?.TimbreFiscalDigital?.uuid ?? value.UUID;

    const pagos = props.comprobante.Complemento?.Pagos?.Pago ?? [];
    let documentos = props.documentos ?? [];

    for (const key in pagos) {
      if (Object.hasOwnProperty.call(pagos, key)) {
        const element = pagos[key].DoctoRelacionado;

        documentos = documentos.concat(element);
      }
    }

    let { FactorajeFinanciero = {} } = value;
    let parcialidad = FactorajeFinanciero?.Parcialidad ?? '1';
    let monto_pendiente = FactorajeFinanciero?.MontoPendiente ?? value.Total;

    for (const key in documentos) {
      if (Object.hasOwnProperty.call(documentos, key)) {
        const element = documentos[key];

        if (uuid === element.IdDocumento) {
          monto_pendiente = DecimalForGlobals.make(
            parseFloat(monto_pendiente) - parseFloat(element.ImpPagado)
          ).toFixed();

          parcialidad = parseInt(element.NumParcialidad) + parseInt(1);

          FactorajeFinanciero = {
            ...FactorajeFinanciero,
            ...element.FactorajeFinanciero,
          };
        }
      }
    }

    let newData = {
      IdDocumento: uuid,
      Serie: value.Serie,
      Folio: value.Folio,
      MonedaDR: value.Moneda,
      EquivalenciaDR: undefined,
      NumParcialidad: parcialidad,
      ImpSaldoAnt: monto_pendiente,
      ImpPagado: monto_pendiente,
      ImpSaldoInsoluto: parseFloat(monto_pendiente) - parseFloat(monto_pendiente),
      ObjetoImpDR: '01',
    };

    setData(newData);

    let newFactoraje = {
      ...factoraje,
      MontoContrato: FactorajeFinanciero.MontoContrato ?? value.FactorajeFinanciero?.MontoContrato ?? value.Total,
      Equivalencia: FactorajeFinanciero.Equivalencia ?? value.FactorajeFinanciero?.Equivalencia ?? '1',
      Moneda: FactorajeFinanciero.Moneda ?? value.FactorajeFinanciero?.Moneda ?? value.Moneda,
      Aforo: FactorajeFinanciero.Aforo ?? value.FactorajeFinanciero?.Aforo,
      Honorarios: FactorajeFinanciero.Honorarios ?? value.FactorajeFinanciero?.Honorarios,
      TasaInteres: FactorajeFinanciero.TasaInteres ?? value.FactorajeFinanciero?.TasaInteres,
    };

    newFactoraje = FactorajeFinancieroCalculator.make(newFactoraje).apply();

    setFactoraje({
      ...factoraje,
      ...newFactoraje,
      monto_contrato: FactorajeFinanciero?.MontoContrato,
    });

    props.onChange({
      MonedaP: value.Moneda,
      TipoCambioP: value.TipoCambio,
    });
  };

  const handleOnAction = (action) => {
    if (action === 'reset') {
      setError(undefined);
    }
  };

  const renderError = () => {
    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={() => {
            handleOnAction('reset');
          }}
        />
      </div>
    );
  };

  const handleOnFactorajeChange = (event) => {
    if (!event.Equivalencia) {
      event.MontoContrato = factoraje.monto_contrato ?? data.ImpSaldoAnt ?? editing.ImpSaldoAnt;
    } else {
      event.MontoContrato = (factoraje.monto_contrato ?? data.ImpSaldoAnt ?? editing.ImpSaldoAnt) * event.Equivalencia;
    }

    setFactoraje({
      ...factoraje,
      ...event,
    });
  };

  return (
    <div data-testid="PagoDocumentoRelacionadoForm">
      {!!error && renderError()}

      <div>
        <strong className="text-upper text-muted">Facturas pagadas</strong>
      </div>
      {Guardian.allows('factoraje_financiero.access') && (
        <Row className="mt-3">
          <Col>
            <UsePreviousCfdiToFillForm onChange={handleOnStartPointChange} />
          </Col>
        </Row>
      )}

      <Row className="mt-3">
        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="text"
            label="Folio Fiscal"
            name="IdDocumento"
            placeholder=""
            help=""
            minLength="16"
            maxLength="36"
            rules={rules.IdDocumento}
            value={data.IdDocumento}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="text"
            label="Serie"
            name="Serie"
            placeholder=""
            help=""
            minLength="1"
            maxLength="25"
            rules={rules.Serie}
            value={data.Serie}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="text"
            label="Folio"
            name="Folio"
            placeholder=""
            help=""
            minLength="1"
            maxLength="40"
            rules={rules.Folio}
            value={data.Folio}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="select"
            label="Moneda"
            name="MonedaDR"
            placeholder=""
            help=""
            rules={rules.MonedaDR}
            value={data.MonedaDR}
            options={MonedaDROptions}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="text"
            label="Equivalencia"
            name="EquivalenciaDR"
            placeholder=""
            help=""
            rules={rules.EquivalenciaDR}
            value={data.EquivalenciaDR}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="text"
            label="Número de parcialidad"
            name="NumParcialidad"
            placeholder=""
            help=""
            rules={rules.NumParcialidad}
            value={data.NumParcialidad}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Importe saldo anterior"
            name="ImpSaldoAnt"
            placeholder=""
            help=""
            rules={rules.ImpSaldoAnt}
            value={data.ImpSaldoAnt}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Importe pagado"
            name="ImpPagado"
            placeholder=""
            help=""
            rules={rules.ImpPagado}
            value={data.ImpPagado}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="number"
            label="Importe saldo insoluto"
            name="ImpSaldoInsoluto"
            placeholder=""
            help=""
            rules={rules.ImpSaldoInsoluto}
            value={data.ImpSaldoInsoluto}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          xs="12"
          sm="6"
          md="4"
        >
          <FormControl
            type="select"
            label="Objeto Impuesto DR"
            name="ObjetoImpDR"
            placeholder=""
            help={data.ObjetoImpDR !== '01' ? 'Debes agregar al menos un impuesto' : ''}
            rules={rules.ObjetoImpDR}
            value={data.ObjetoImpDR}
            options={ObjetoImpDR}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <DocumentoRelacionadoImpuestos
        data={data}
        onChange={handleOnImpuestosChange}
      />

      {Guardian.allows('factoraje_financiero.access') && (
        <FactorajeForm
          data={factoraje}
          input={data}
          onChange={handleOnFactorajeChange}
        />
      )}

      <Row>
        <Col className="text-right pb-2">
          <Button
            variant="secondary"
            disabled={!isValid}
            onClick={handleOnAdd}
          >
            Agregar factura
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default DocumentoRelacionadoForm;
